import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import styled from "styled-components";
import Button from "components/Button";
import TextField from "components/TextField";
import routes from "core/Routes";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { login } from "store/slices/userSlice";
import themeProps from "theme/themes";
import ButtonLink from "components/Button/ButtonLink";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: calc(100vh - 60px);
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 60px;
  border: 1px solid ${(props: themeProps) => props.theme.main.primary};
  border-radius: 12px;
  width: 50%;
  max-width: 400px;
  margin-top: 10vh;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Text = styled.p`
  margin-bottom: 24px;
  font-size: 1.2rem;
`;

const Heading = styled.h1`
  margin-bottom: 24px;
`;

const Login = () => {
  const { t } = useTranslation("forms");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const history = useHistory();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.user.auth.access_token);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  useEffect(() => {
    if (token) {
      history.push(routes.explore.root);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <Wrapper>
      <FormWrapper>
        <Heading>{t("loginTitle")}</Heading>
        <Form>
          <TextField
            placeholder={t("email")}
            value={email}
            onChange={setEmail}
            styles={{ marginBottom: "24px" }}
          />
          <TextField
            placeholder={t("password")}
            value={password}
            type="password"
            onChange={setPassword}
            styles={{ marginBottom: "24px" }}
          />
          <Button
            label={t("login")}
            onClick={(e: any) => {
              handleSubmit(e);
            }}
            styles={{ marginBottom: "24px" }}
            filled
          />
          <Text>{t("or")}</Text>
          <ButtonLink label={t("register")} to={routes.register} />
        </Form>
      </FormWrapper>
    </Wrapper>
  );
};

export default Login;
